import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/r2r-property',
    name: 'R2R Property',
    component: () => import('../views/R2RProperty.vue')
  },
  {
    path: '/property-maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance.vue')
  },
  {
    path: '/landlord-services',
    name: 'landloard-services',
    component: () => import('../views/PBS.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/myworkman',
    name: 'myworkman',
    beforeEnter: () => window.open('https://www.myworkman.co.uk/trade-profile/view/19249/dod-property-services-midland-gutter-masters/')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
